import { useMatch } from '../components/tournaments/match/MatchProvider';
import {
  toName,
  toAvatar,
} from 'functions/src/types/firestore/Game/Tournament/Guestlist/util';
import { toOutcome } from '../components/tournaments/brackets/util/bracketFunctions';
import {
  MatchCompetitor,
  MatchCompetitorProps,
} from '../components/tournaments/match/MatchCompetitor';
import { MatchAggregated } from 'functions/src/types/firestore/Game/Tournament/Bracket';

export function toMatchCompetitors({
  team1Score,
  team2Score,
  winner,
  team1,
  team2,
}: Pick<
  MatchAggregated<Date>,
  'team1Score' | 'team2Score' | 'team1' | 'team2' | 'winner'
>) {
  return [
    {
      competitor: team1
        ? { name: toName(team1), avatarUrl: toAvatar(team1) }
        : undefined,
      score: team1Score,
      outcome: toOutcome(team1, team2, winner),
    },
    {
      competitor: team2
        ? { name: toName(team2), avatarUrl: toAvatar(team2) }
        : undefined,
      score: team2Score,
      outcome: toOutcome(team2, team1, winner),
    },
  ];
}

export type UseMatchCompetitorsOptions = {
  CompetitorComponent?: React.ComponentType<
    MatchCompetitorProps & { index?: number }
  >;
};

export const useMatchCompetitors = ({
  CompetitorComponent = MatchCompetitor,
}: UseMatchCompetitorsOptions = {}) => {
  const { team1Score, team2Score, winner, team1, team2 } = useMatch();
  const competitors = toMatchCompetitors({
    team1Score,
    team2Score,
    winner,
    team1,
    team2,
  });

  const MatchCompetitors = competitors.map((props, index) => {
    return (
      <CompetitorComponent
        {...props}
        index={index}
        key={props.competitor?.name}
      />
    );
  });
  return { MatchCompetitors };
};
